import { number, string, type } from "superstruct";

const InstagramTaggedProductSchema = type({
    product: type({
        description: string(),
    }),
    reviewsCount: number(),
    questionsCount: number(),
});

export default InstagramTaggedProductSchema;
